import React from 'react';
import Seo from './Seo.tsx';

/** Rendered for unknown paths; noindex so the SPA fallback never becomes a soft 404 in search. */
const NotFoundPage: React.FC = () => (
  <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 text-neutral-900 dark:text-neutral-100 font-sans flex items-center justify-center px-6">
    <Seo title="Page not found | Ben Smith" description="That page doesn't exist." path={window.location.pathname} noindex />
    <div className="text-center max-w-md">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">Page not found</h1>
      <p className="text-lg text-neutral-600 dark:text-neutral-400 mb-8">That page doesn't exist, or it moved.</p>
      <a href="/" className="inline-flex items-center bg-primary-600 dark:bg-primary-500 text-white font-semibold py-3 px-8 rounded-full hover:bg-primary-700 dark:hover:bg-primary-600 transition-all duration-300">
        Back to the homepage
      </a>
    </div>
  </div>
);

export default NotFoundPage;
